import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'userManagement.3pc.territoryDialog.title' }),
    searchTerritory: translate({ id: 'userManagement.3pc.territoryDialog.textFieldPlaceholder' }),
    noOptions: translate({ id: 'userManagement.3pc.territoryDialog.noOptions' }),
  }))

  return api
}
